import { MenuItem } from './index';

export const getMenuOpened = (menus: MenuItem[]) => {
  const opened = {} as Record<number, unknown>;
  (menus || []).map((menu: MenuItem, i: number) => {
    opened[i] = !!menu.defaultOpen;
  });
  return opened;
};
